export default __webpack_public_path__ + "static/media/feature-chat.7b6e61cd.png";